import React from 'react'
import Content from '../Content/Content'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'


const Layout = () => {
  return (
    <div className=''>
        <Header />
          <Content />
          <Footer />
        
        
    </div>
  )
}

export default Layout